export const environment = {
  production: true,
  envApi: 'https://aeqt.mhc.hbxshop.org',
  cataract_api: 'http://localhost:3001', // update this later. fixing for build
};
